import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-educativa-reserva-lista',
  templateUrl: './educativa-reserva-lista.component.html',
  styleUrls: ['./educativa-reserva-lista.component.css']
})
export class EducativaReservaListaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public fechaIni = ''; public fechaFin = ''; public encabezado: string = ""; public nombreBeca: string = "";
  vecCitas: Array<any> = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private alerti: AlertifyService) { }


  ngOnInit() {
    this.encabezado = "Lista de citas reservadas";
    this.nombreBeca = localStorage.getItem('modNom');

    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.fechaIni = new Date().toLocaleDateString();
    this.fechaFin = new Date().toLocaleDateString();
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN REQUISITO
  verModalFechas(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE MUESTRA EL REPORTE REPORTE DE CITAS RESERVADAS localStorage.getItem('ciUsuario')
  async verCitasReservadas() {
    this.vecCitas = [];
    const resCitas = await new Promise<any>(resolve =>
      this.srvSelect.medicoverHCE(6, localStorage.getItem('ciUsuario'), this.fechaIni, this.fechaFin).subscribe(translated => {
        resolve(translated)
      }));
    if (resCitas.success)
      this.vecCitas = resCitas.citas;
    else
      this.alerti.warning('No se encontraron citas las fechas indicadas');
    this.dtTrigger.next();
    this.mr.close();
  }

}
